<template>
    <div id="downloadDetail">
        <sidebar :content="sidebarData"></sidebar>
        <div id="content">
          <bread :content="breadContent"></bread>
          <p class="Page-title">{{pageTypeCN[this.pageState]}}</p>
          <el-divider></el-divider>
          <Article :title="title" :subTitle="subTitle" :html="content" margin="0 44px 0 0"></Article>
          <div class="bottom">
            <img src="../../assets/pdf.png">
            <p @click="clickDownload">点击下载：{{ title }}</p>
          </div>
        </div>
    </div>
</template>
<script>
import sidebar from "@/components/sidebar"
import bread from "@/components/bread"
import Article from '@/components/article'

export default {
  components: {
    sidebar,
    bread,
    Article
  },
  name: "downloadDetail",
  computed: {
    breadContent(){
      return [
        { text: "首页", routerName: "index" },
        { text: "下载中心", routerName: "dldText" },
        { text: this.pageTypeCN[this.pageState], routerName: "" },
      ]
    } 
  },
  data() {
    return {
      pageState: 0,
      pageTypeCN: ['学术交流', '应急常识', '在线视频'],
      pageType: ['academic', 'knowledge', 'video'],
      sidebarData: {
        title: "下载中心",
        sub: [
          {
            title: "学术交流",
            sub: [],
            url:'/index/download/academic',
          },
          {
            title: "应急常识",
            sub: [],
            url:'/index/download/knowledge',
          },
          {
            title: "在线视频",
            sub: [],
            url:'/index/download/video',
          },
        ]
      },
      title: '',
      subTitle: '',
      content: '',
      downloadUrl: ''
    }
  },
  methods: {
    async getData() {
      const res = await this.$net.index.getDownloadDetail(this.$route.query.id)
      this.title = res.Title
      this.subTitle = res.ViceTitle
      this.content = res.Content
      this.downloadUrl = res.DownloadUrl
    },
    clickDownload() {
      if (!this.downloadUrl) {
        // 如果未登录后端返回此属性为空
        if (localStorage.Authorization) {
          alert('编辑未提供下载链接')
        } else {
          alert('登陆后才可以下载该文档！')
        }
      } else {
        window.open(this.downloadUrl)
      }
    }
  },
  async created() {
    this.pageState = this.pageType.findIndex(item => item === this.$route.params.type)
    this.$store.commit('setHighlightText', this.breadContent[2].text)
    this.getData()
  },
  // watch: {
  //   // 如果路由有变化，会再次执行该方法
  //   '$route': 'getData',
  // },
  destroyed() {
    this.$store.commit('setHighlightText', '')
  }
}
</script>
<style lang="scss" scoped>
#downloadDetail {
  display: flex;
  width: 80%;
  margin: 0 auto;
  padding: 40px 0 160px 0;
}
#content{
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
#card-content{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.downloadCard{
  width: 45%;
  margin-bottom: 30px;
}
.bottom {
  display: flex;
  align-items: center;
  margin-top: 50px;
  // margin-left: 10%;
  img {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }
  p {
    display: inline-block;
    color: $standard-blue;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>

